export default __webpack_public_path__ + "2e5695d1dbc4608c723a7503c74b7ea6.svg";